import $  from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';
import './styles.scss';

export default class Formulary {
  constructor(config, $modules) {
    let props ={
      path: config.path
    };
    let el = $modules;
    if (el === undefined) return;
    $modules.each((index, el) => {
        ReactDOM.render(React.createElement(App, props), el);
    });
  }
}
Formulary.selector = '[data-module="Formulary"]';
Formulary.init = (config,$modules) => {
  $modules = $modules || $(Formulary.selector);
  new Formulary(config,$modules);
}



// WEBPACK FOOTER //
// ./medscape_modules/formulary/index.js